/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import Modal from "../../../components/Modal";
import BondDebt from "../../../components/Client/BondDebt";

const FundsBondDebt = ({ open, setOpen, data, filterParams, type }) => {
  const cancel = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  useEffect(() => {
    //console.log(data);
  }, [data]);
  return (
    <Modal isOpen={open} close={cancel}>
      <div className="bond-debt-detail">
        <BondDebt
          filterParams={filterParams}
          data={data}
          type={type}
        />
      </div>
    </Modal>
  );
};

export default FundsBondDebt;
